/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Controls/Edit': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M5.202 24.754a.25.25 0 00-.414.098l-.775 2.324a.25.25 0 00.316.316l2.325-.775a.25.25 0 00.097-.413l-1.549-1.55zm5.724-1.347L8.098 20.58 20.951 7.724l2.83 2.83-12.855 12.853zm16.566-11.97l-1.06-1.06-1.944-1.945 1.944-1.945a.249.249 0 000-.353l-1.06-1.06a.249.249 0 00-.354 0l-1.946 1.944-1.944-1.944a.249.249 0 00-.353 0L6.683 19.166c-.024.023-1.125 3.363-1.367 4.099a.242.242 0 00.062.25l2.606 2.607c.07.07.17.096.262.064.748-.245 4.07-1.34 4.094-1.364L25.902 11.26l.707.707-5.658 5.657-1.237 1.238a.25.25 0 000 .354l.354.353a.249.249 0 00.353 0l1.237-1.239 5.834-5.832a.752.752 0 000-1.062z"/>'
  }
})
